import { StyleSheet } from 'aphrodite';
import { borderColor, brandPrimary, brandPrimaryHover, label, white } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	splitView: {
		minHeight: '100%',
	},
	profile: {
		padding: '24px 30px 0 0',
		position: 'relative',
	},
	loading: {
		marginTop: 30,
	},
	profileHeader: {
		textAlign: 'right',
	},
	editButton: {
		fontSize: 14,
		color: brandPrimaryHover,
		lineHeight: '20px',
	},
	tabContainer: {
		height: '100%',
		display: `flex`,
		flexDirection: `column`,
	},
	tabContent: {
		height: '100%',
		overflow: `auto`,
		boxSizing: `border-box`,
		paddingRight: 16,
	},
	tabList: {
		borderBottom: `1px solid ${borderColor}`,
		boxSizing: `border-box`,
		display: `flex`,
		width: `100%`,
		background: white,
	},
	automationPopover: {
		fontSize: 14,
		letterSpacing: '0',
		padding: '5px 10px',
	},
	automationPopoverMessage: {
		color: label,
		padding: '5px 12px',
	},
	automationPopoverName: {
		color: brandPrimary,
		padding: '5px 12px',
	},
	automationStartButton: {
		margin: '10px 10px',
		padding: '5px 12px',
	},
	tabTrigger: {
		flexGrow: 1,
		flexBasis: 0,
		fontSize: `0.875rem`,
		justifyContent: `center`,
		alignItems: `center`,
		display: `flex`,
		textTransform: 'uppercase',
		letterSpacing: `1.2px`,
		textDecoration: 'none',
		padding: 20,
		':is([data-state="active"])': {
			color: brandPrimary,
			borderBottom: `3px solid ${brandPrimary}`,
		},
	},
});
